import React from 'react';
import PropTypes from 'prop-types';
import Option from '../Option';

const OtherOptionControl = props => {
  const { enabled, checked, onChange, type, optionProps } = props;

  if (enabled) {
    return <Option type={type} checked={checked} text="Other" onChange={onChange} {...optionProps} />;
  }
  return null;
};

OtherOptionControl.propTypes = {
  checked: PropTypes.bool,
  enabled: PropTypes.bool,
  onChange: PropTypes.func,
  optionProps: PropTypes.object,
  type: PropTypes.oneOf(['pills', 'checklist', 'radio'])
};

export default OtherOptionControl;
